<template>
  <Appendix
    title="Biên bản bàn giao"
    :fields="fieldsTable"
    :actions="actions"
    :excepts="excepts"
    :only="only"
    :items="items"
    :contract="contract"
  >
    <template #row-details="item">
      Lý do bàn giao: {{ item.appendixHandOver.handOverReason | findIdText(Config.reasonHandOver) }}
      <DeviceInfoAppendix :items="item.appendixHandOver.devices" :fields="deviceFields">
      </DeviceInfoAppendix>
      <LocationInfoAppendixVue
        :items="[
          {
            ...item.appendixHandOver,
            ...(item.merchantBusinessAreas ? item.merchantBusinessAreas[0] : {}),
          },
        ]"
      />
      <AttachedApendix
        v-if="item.appendixHandOver.appendixWarrantyCode"
        :items="[item.appendixHandOver]"
      />
    </template>
    <template #file="item">
      <AppendixHandoverFile :item="item" />
      <div v-if="item.files?.length" class="form-detail">
        <UploadMultiple
          :lsData="item.files"
          keyUrl="urlPDF"
          :canUpload="false"
          title="File xác nhận bàn giao"
          titleTag="h1"
          titleClass="form-inner-heading"
        />
      </div>
    </template>
  </Appendix>
</template>
<script>
  import Config from '@/thirdParty/config'
  import Appendix from './Appendix.vue'
  import DeviceInfoAppendix from './DeviceInfoAppendix.vue'
  import LocationInfoAppendixVue from './LocationInfoAppendix.vue'
  import AttachedApendix from './AttachedApendix.vue'
  import AppendixHandoverFile from './files/AppendixHandoverFile.vue'
  import UploadMultiple from '@/components/UploadMultiple.vue'

  export default {
    props: {
      actions: {
        type: Function,
      },
      excepts: {
        type: Array,
        default: () => [],
      },
      only: {
        type: Array,
        default: () => [],
      },
      items: {
        type: Array,
        default: () => [],
      },
      contract: {
        type: Object,
        default: () => {},
      },
    },
    components: {
      Appendix,
      DeviceInfoAppendix,
      LocationInfoAppendixVue,
      AttachedApendix,
      AppendixHandoverFile,
      UploadMultiple,
    },
    data() {
      return {
        Config,
        fieldsTable: [
          { key: 'code', label: 'Mã biên bản', class: 'text-left' },
          {
            key: 'time',
            label: 'Thời gian',
            class: 'text-left',
            thStyle: 'min-width: 210px',
          },
          { key: 'numDevices', label: 'SL thiết bị', class: 'text-right' },
          { key: 'state', label: 'Trạng thái', class: 'text-center' },
          { key: 'action', label: 'Thao tác', class: 'text-center' },
        ],
        deviceFields: [
          { key: 'displayName', label: 'Tên thiết bị', class: 'text-left' },
          { key: 'serialNumber', label: 'Mã serial', class: 'text-left' },
          { key: 'handoverDevice', label: 'Bàn giao thay cho TB', class: 'text-left' },
        ],
      }
    },
    methods: {
      dataLocation(appendixHandOver, merchantBusinessAreas) {
        const data = {
          ...appendixHandOver,
          ...merchantBusinessAreas,
        }
        return data
      },
    },
  }
</script>

<style scoped></style>
